import React,{useState,useEffect}from "react";
import "../Styles/ProfileFlightHistoryPage.css";
import api from "../Api.js"
import { useNavigate } from "react-router-dom";




function formatDate(dateString) {
    const date = new Date(dateString);

    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Get parts
    const dayName = days[date.getDay()];
    const day = date.getDate();
    const monthName = months[date.getMonth()];

    // Add ordinal suffix
    const getOrdinal = (n) => {
        if (n % 10 === 1 && n % 100 !== 11) return n + "st";
        if (n % 10 === 2 && n % 100 !== 12) return n + "nd";
        if (n % 10 === 3 && n % 100 !== 13) return n + "rd";
        return n + "th";
    };

    return `${dayName} ${getOrdinal(day)} ${monthName}`;
}
const FlightBookingHistory = () => {
  const navigate = useNavigate();
  const [flightBooking,setFlightBooking]=useState([])
  const accesstoken = localStorage.getItem("accessToken");

  useEffect(()=>{
    const fetchFlightBookList = async () => {
  try {
    const accessToken = "71|9xZpoTNtFHdoJ5ejcN1FvLa7TupaokKeH1DItPZYdbe34441";

    const response = await api.post(
      "/flights/book-list",
      {}, // POST body (empty as per curl)
      {
        headers: {
          Authorization: `Bearer ${accesstoken}`,
          Accept: "application/json",
        },
      }
    );

    console.log("Flight Book List:", response.data);
    setFlightBooking(response?.data?.data);

  } catch (error) {
    console.error(
      "Error fetching flight book list:",
      error.response?.data || error.message
    );
  }
};

fetchFlightBookList();
  },[])
  const ConfirmFlight = flightBooking?.filter(item => item?.booking_status === "CONFIRMED")



  const handleTicket=(item)=>{
    const transferData = {
      TraceID: item?.payload?.responseData?.Response?.TraceId,
      BookingId: item?.payload?.responseData?.Response?.Response?.BookingId,
      PNR : item?.payload?.responseData?.Response?.Response?.PNR
    }

    navigate("/flight-ticket",{state:{ FlightDataFromHistoryPage: transferData }})

  }
  return (
    <div className="booking-history-page">
     

      {ConfirmFlight.map((item) => (
        <div className="booking-card" key={item?.id}>
          {/* Top Row */}
          <div className="booking-top">
            <div className="route">
              <span>{item?.payload?.responseData?.Response?.Response?.FlightItinerary?.Origin}</span>
              <span className="arrow5">→</span>
              <span>{item?.payload?.responseData?.Response?.Response?.FlightItinerary?.Destination}</span>
            </div>
            <div className="pnr">PNR: {item?.payload?.responseData?.Response?.Response?.PNR}</div>
            <div className="pnr" style={{color:"green"}}>Status: {item?.booking_status}</div>
          </div>

          {/* Middle Info */}
          <div className="booking-info">
            <div><label>Date</label><span>{formatDate(item?.payload?.responseData?.Response?.Response?.FlightItinerary?.LastTicketDate)}</span></div>
            <div><label>Airline</label><span>{item?.payload?.responseData?.Response?.Response?.FlightItinerary?.AirlineCode}</span></div>
            <div><label>Flight</label><span>{item?.payload?.responseData?.Response?.Response?.FlightItinerary?.TBOConfNo}</span></div>
            <div><label>Seat</label><span>{item?.meta?.seatCodes.map(item => item)}</span></div>
            <div><label>Meal</label><span>{item?.payload?.responseData?.Response?.Response?.FlightItinerary?.Passenger.flatMap(pax =>pax.MealDynamic?.map(meal =>meal?.AirlineDescription))}</span></div>
            <div><label>Baggage</label><span>{item?.payload?.responseData?.Response?.Response?.FlightItinerary?.Passenger.flatMap(pax =>pax.Baggage?.map(bag => bag?.Weight))}kg</span></div>
          </div>

          {/* Bottom Row */}
          <div className="booking-footer">
            <div className="amount">₹{item?.price}</div>
            <button className="details-btn" onClick={()=>handleTicket(item)}>Show Details</button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FlightBookingHistory;
